import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { UserService } from '../../services/user-service/user.service';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { DialogService } from '../../customs/_modal/dialog.service';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [RouterLink, MatFormFieldModule, CommonModule,MatInputModule, MatButtonModule, MatCheckboxModule, ReactiveFormsModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {

  forgotPasswordForm: FormGroup;
  isToggled = false;
  message = '';
  error = '';

  constructor(
    public themeService: CustomizerSettingsService,
    private fb: FormBuilder,
    private authService: UserService,
    private router: Router,
    private dialogService: DialogService

  ) {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });

    this.themeService.isToggled$.subscribe(isToggled => {
      this.isToggled = isToggled;
    });
  }

onSubmit() {
  if (this.forgotPasswordForm.valid) {
    const email = this.forgotPasswordForm.value.email;
    console.log('[INFO] Envoi de la requête de réinitialisation pour:', email);

    this.authService.forgotPassword(email).subscribe({
      next: (res) => {
        console.log('[SUCCESS]', res);
        this.dialogService.openSuccessDialog('Un email de réinitialisation a été envoyé à cet email .')

        this.error = '';
      },
      error: (err: any) => {
        console.error('[ERREUR] lors de la demande de réinitialisation', err);
        this.dialogService.openDangerDialog( 'Erreur lors de l\'envoi de l\'email.');

        this.message = '';
      }
    });
  }
}

}
